import "core-js/modules/es6.function.name";
import * as React from "react";
import Shell from "../layout/shell";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import "./contact-us.scss";

var ContactUs = function ContactUs(_ref) {
  var data = _ref.data;
  var content = data.prismic.allContact_uss.edges[0].node.body[0];
  return /*#__PURE__*/React.createElement(Shell, null, /*#__PURE__*/React.createElement("div", {
    className: "image-feature-block contact-block right-align-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width",
    style: {
      backgroundImage: "url('" + content.primary.background_image['url'] + "')"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-block"
  }, /*#__PURE__*/React.createElement("h4", null, content.primary.header), content.fields.map(function (contact) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, handleLineBreaks(contact.name)), /*#__PURE__*/React.createElement("a", {
      href: "mailto:" + contact.email_address
    }, handleLineBreaks(contact.email_address)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
      href: "tel:" + contact.contact_number
    }, handleLineBreaks(contact.contact_number)));
  }), /*#__PURE__*/React.createElement("p", null, "For general enquries contact ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:" + content.primary.general_enquiries_email
  }, content.primary.general_enquiries_email))))));
};

export default ContactUs;
export var query = "3048493127";